import type { SelectOption } from '@/shared/ui/form/SelectTextField';
import { i18n } from '@/shared/i18n';

// Getters, not values: this array is built while the module is evaluated, so resolving per
// read is what lets an option follow a language change instead of freezing at import.
export const GENDER_OPTIONS: SelectOption[] = [
  {
    get label() {
      return i18n.t('audiences:audiences.personaFieldsConstants.female');
    },
    // eslint-disable-next-line i18next/no-literal-string -- persisted as the persona's gender value; the getter above carries the copy
    value: 'female',
  },
  {
    get label() {
      return i18n.t('audiences:audiences.personaFieldsConstants.male');
    },
    // eslint-disable-next-line i18next/no-literal-string -- persisted as the persona's gender value; the getter above carries the copy
    value: 'male',
  },
  {
    get label() {
      return i18n.t('audiences:audiences.personaFieldsConstants.nonBinary');
    },
    value: 'non-binary',
  },
  {
    get label() {
      return i18n.t('audiences:audiences.personaFieldsConstants.other');
    },
    // eslint-disable-next-line i18next/no-literal-string -- persisted as the persona's gender value; the getter above carries the copy
    value: 'other',
  },
];

// eslint-disable-next-line i18next/no-literal-string -- persisted as `UpdatePersonaDto.age` and compared against the API's stored age; AGE_OPTIONS carries the copy
export const AGE_VALUES = ['Under 18', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'] as const;

const [AGE_UNDER_18, ...AGE_RANGES] = AGE_VALUES;

export const AGE_OPTIONS: SelectOption[] = [
  {
    get label() {
      return i18n.t('audiences:audiences.personaFieldsConstants.ageUnder18');
    },
    value: AGE_UNDER_18,
  },
  // The numeric ranges read the same in every locale.
  ...AGE_RANGES.map((value) => ({ label: value, value })),
];

/* eslint-disable i18next/no-literal-string -- persisted verbatim as `PersonaRequestDto.toneOfVoice`, a free-form string array; the field is freeSolo, so a picked suggestion becomes the stored value and rewording one would fork it from every persona already saved */
export const TONE_OF_VOICE_OPTIONS = [
  'Professional',
  'Casual',
  'Friendly',
  'Playful',
  'Bold',
  'Formal',
];
/* eslint-enable i18next/no-literal-string */
